export class TaxRateModel {
  public id: string;
  public name: string = '';
  public rate: number;
  public isDefault: boolean;
  public createdOn: string;
}
